import React from 'react';
import { EmptyListBox } from './styles';

export const EmptyListMessage = () => (
  <EmptyListBox>No spaces have been added.</EmptyListBox>
);
